import qs from 'qs'
import request from '@/utils/request'
import  common_api  from '../config'


// 获取商品详情
const news = {
    getNews: function(params) {
    return request({
      url:  common_api + '/website/notice/anonymous/list',
      method: 'get',
      params: params
    })
  },
  getNewsDetail: function(params) {
    return request({
      url:  common_api + `/website/notice/anonymous/${params.id}`,
      method: 'get',
    })
  },

}
export default news



// WEBPACK FOOTER //
// ./src/api/Interface/news.js